/**
 * The plugins that have been loaded
 */
import { SET_PLUGINS } from "../actionTypes.js";
import { replaceReducer } from "./common/index.js";
export default replaceReducer(SET_PLUGINS, null);
//# sourceMappingURL=plugins.js.map